import 'jquery';
import '../utils/slick.js';

$(function () {
    const blockHeroLogos = $(".block-brands__logos");
    blockHeroLogos.slick({
        arrows: false,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: "linear",
        dots: false,
        infinite: true,
        slidesToShow: 8,
        speed: 6000,
        swipe: false,
        pauseOnHover:false,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 6,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 5,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                }
            }
        ],
        init: function(event, slick) {
            blockHeroLogos.find('.slick-slide').css('opacity', 0);
            blockHeroLogos.find('.slick-slide').animate({ opacity: 1 }, 500);
        }
    });
});